import { memo, type ReactNode } from "react";

export interface CustomNotFoundProps {
  notFoundText?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

function CustomNotFound({
  notFoundText,
  icon,
  className = "",
}: CustomNotFoundProps) {
  return (
    <div
      className={`flex items-center justify-center h-32 w-full ${className}`.trim()}
    >
      <div className="flex flex-col items-center text-center gap-2">
        {icon && <div className="mb-1">{icon}</div>}
        {notFoundText}
      </div>
    </div>
  );
}

export default memo(CustomNotFound);
